import React from 'react';
import strings from "../../localization";
import { bindActionCreators } from "redux";
import { withSnackbar } from "notistack";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import * as Actions from "../../actions/Actions";
import Page from '../../common/Page';
import { getRenewalTypes } from '../../util/ReviewsUtil';
import update from 'immutability-helper';
import { getAllGraveyards } from '../../services/graveyard/GraveyardService';
import {
    generateRenewalProcessingPdf,
    getEditedRenewalsForProcessing,
    loadProcessingReport,
    getAllProcessingReports,
    createProcessingReport,
    generateRenewalProcessingPdfWithoutDiscount,
    generateRenewalPrePdf,
    updateProcessingReport
} from '../../services/renewalEdited/RenewalEditedService';

import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import SaveIcon from '@material-ui/icons/Save';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';

import RenewalProcessingHeader from './RenewalProcessingHeader';
import RenewalProcessingReportHeader from './RenewalProcessingReportHeader';
import { dateToString3, dateToStringDatePickerFormat3, dateTimeToString } from '../../util/DateUtil';
import RenewalProcessingResult from './RenewalProcessingResult';

// The server sorts every fetched page on its own; once the pages are merged the whole list
// has to be sorted again (same order as the backend's RenewalOrdering), so that the screen,
// the saved report and the printed documents all show the grave sites in the same order.
function sortByGraveyardAndGraveSite(renewals) {
    const compare = (a, b) => {
        if (a === b) return 0;
        if (a === null || a === undefined) return 1;
        if (b === null || b === undefined) return -1;
        return a < b ? -1 : 1;
    };

    return renewals.sort((x, y) =>
        compare(x.graveyardId, y.graveyardId) || compare(x.graveSiteCode, y.graveSiteCode));
}

class RenewalProcessingList extends Page {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            selectRenewalType: [],
            selectRenewalTypeKind: [],
            editedResult: false,
            excludedIds: [],
            editedItems: {},
            searchCriteria: {},
            data: {
                selectedRenewalType: { id: -1 },
                selectedRenewalTypeKind: { id: -1, value: -1 },
                selectedYear: { value: -1 },
                selectedGraveyard: { id: -1 },
                selectedGraveSite: { id: -1 },
                selectedReport: { id: -1 },
                field: null,
                plot: null,
                graveSiteNumber: null,
            },
            discounts: [],

        }

        this.state.sortBy = "renewalNumber,ASC";
        this.changeData = this.changeData.bind(this);
        this.find = this.find.bind(this);
        this.hideTableShowSearch = this.hideTableShowSearch.bind(this);
        this.loadReport = this.loadReport.bind(this);
        this.downloadPreReport = this.downloadPreReport.bind(this);
        this.state.discounts = [];
    }

    componentDidMount() {
        this.setState({
            companyId: this.props.auth.user.company.id,
            selectRenewalType: renewalSearch(),
            selectRenewalTypeKind: getRenewalTypes(),


        });

        getAllGraveyards().then(response => {
            this.setState({
                ...this.state,
                graveyards: response.data.entities
            })
        });

        getAllProcessingReports().then(response => {
            const modifiedData = response.data.entities
                .map(item => {
                    const formattedDate = dateTimeToString(item.dateCreated);

                    return {
                        ...item,
                        dateCreated: formattedDate
                    };
                });

            this.setState({
                ...this.state,
                //reports: response.data.entities
                reports: modifiedData
            })
        });
    }

    componentWillReceiveProps(nextProps) {
        strings.setLanguage(nextProps.auth.user.language);
        this.setState({
            selectRenewalType: renewalSearch(),
            selectRenewalTypeKind: getRenewalTypes(),
        });
    }

    addNewDiscount() {
        if (this.state.discounts.length >= 3) {
            return;
        }

        this.setState({
            ...this.state,
            discounts: [...this.state.discounts, { years: 0, percent: 0 }],
        });
    }

    changeData(event, data = 'data') {
        this.setState({
            [data]: update(this.state[data], { [event.target.name]: { $set: event.target.value } })
        }, () => {
            if (event.target && event.target.name == 'renewalProcessingFromDate') {
                const renewalProcessingToDate = new Date(event.target.value);

                const is1stOfApril = (renewalProcessingToDate.getMonth() === 3 && renewalProcessingToDate.getDate() === 1);
                const is31stOfDecember = (renewalProcessingToDate.getMonth() === 11 && renewalProcessingToDate.getDate() === 31);

                if (is1stOfApril || is31stOfDecember) {
                    renewalProcessingToDate.setDate(renewalProcessingToDate.getDate());
                } else {
                    const date1stOfApril = new Date(renewalProcessingToDate.getFullYear(), 3, 1);
                    const date31stOfDecember = new Date(renewalProcessingToDate.getFullYear(), 11, 31);

                    renewalProcessingToDate.setDate(renewalProcessingToDate.getDate() + 4);

                    const newDate = new Date(renewalProcessingToDate);
                    const fromDate = new Date(event.target.value);

                    const is1stAprilOrBeyond = fromDate < date1stOfApril && newDate >= date1stOfApril;
                    const is31stDecemberOrBeyond = fromDate < date31stOfDecember && (newDate.getFullYear() != date31stOfDecember.getFullYear() || newDate.getDate() === 31);

                    if (is1stAprilOrBeyond) {
                        renewalProcessingToDate.setDate(date1stOfApril.getDate() - 1);
                    }
                    if (is31stDecemberOrBeyond) {
                        renewalProcessingToDate.setDate(30);
                        renewalProcessingToDate.setMonth(11);
                        renewalProcessingToDate.setFullYear(fromDate.getFullYear());
                    }
                }

                this.setState({
                    data: {
                        ...this.state.data,
                        renewalProcessingToDate: event.target.value ? renewalProcessingToDate : null,
                    }
                });
            }
        });
        this.writeLineObject(event);

        this.restartSelects(event.target.name);
    }

    restartSelects(eventName) {
        if (eventName == "selectedRenewalType") {
            this.setState({
                data: {
                    ...this.state.data,
                    selectedRenewalTypeKind: { id: -1, value: -1 },
                    selectedYear: { value: new Date().getFullYear() },
                    selectedGraveyard: { id: -1 },
                    selectedGraveSite: { id: -1 },
                }
            }, () => {
                this.setState({
                    obj: {
                        ...this.state.obj,
                        renewalTypeKind: null,
                        year: null,
                        selectedGraveSite: null,
                        selectedGraveyard: null,
                        deceasedNameSurname: null,
                        nameSurnameSubmitter: null,
                    }
                })
            });

        }
    }

    getPageHeader() {
        return <h1>{strings.renewalProcessing.headerTitle}</h1>;
    }



    writeLineObject(e) {
        if (e.target.name == "selectedRenewalType") {
            this.setState({
                obj: {
                    ...this.state.obj,
                    renewalType: e.target.value
                },
                data: {
                    ...this.state.data,
                    selectedRenewalType: e.target.value
                }
            })


        }

        if (e.target.name == "selectedRenewalTypeKind") {
            this.setState({
                obj: {
                    ...this.state.obj,
                    renewalTypeKind: e.target.value
                }
            })
        }

        if (e.target.name == "graveyard") {
            this.setState({
                data: {
                    ...this.state.data,
                    selectedGraveyard: e.target.value
                },
                obj: {
                    ...this.state.obj,
                    selectedGraveyard: e.target.value
                }
            })
        }

        if (e.target.name == "selectedYear") {
            this.setState({
                obj: {
                    ...this.state.obj,
                    year: e.target.value
                }
            })
        }

        if (e.target.name == "graveSite") {
            this.setState({
                obj: {
                    ...this.state.obj,
                    selectedGraveSite: e.target.value
                }
            })

        }

        if (e.target.name == "selectedReport") {
            this.setState({
                data: {
                    ...this.state.data,
                    selectedReport: e.target.value
                },
                obj: {
                    ...this.state.obj,
                    selectedReport: e.target.value
                }
            })
        }
    }

    onAutocompleteChange = (event, values) => {
        let autocompleteName = event.target.id.split("-")[0];
        this.setState({
            data: {
                ...this.state.data, [autocompleteName]: values
            },
            obj: {
                ...this.state.obj,
                selectedGraveSite: values
            }
        });
    }

    handleSaveReport() {
        if (this.state.viewingSavedReport) {
            this.updateExistingReport();
            return;
        }

        let data = {
            graveyardId: this.state.searchCriteria.graveyardId,
            field: this.state.searchCriteria.field,
            plot: this.state.searchCriteria.plot,
            graveSiteNumber: this.state.searchCriteria.graveSiteNumber,
            selectedRenewalTypeKind: this.state.searchCriteria.selectedRenewalTypeKind,
            excludedIds: this.state.excludedIds,
            editedRenewals: Object.values(this.state.editedItems),
        }

        const fromDate = this.state.data.renewalProcessingFromDate ? this.state.data.renewalProcessingFromDate.toISOString() : null;
        const toDate = this.state.data.renewalProcessingToDate ? this.state.data.renewalProcessingToDate.toISOString() : null;

        createProcessingReport(data, fromDate, toDate).then(response => {
            if (response.ok) {
                this.props.enqueueSnackbar(strings.renewalList.reportSaved, {
                    variant: "success",
                });
                this.hideTableShowSearch();
            }

            getAllProcessingReports().then(response => {
                this.setState({
                    ...this.state,
                    reports: response.data.entities
                })
            });
        });
    }

    updateExistingReport() {
        const editedRenewals = Object.values(this.state.editedItems);

        if ((!this.state.excludedIds || this.state.excludedIds.length === 0) && editedRenewals.length === 0) {
            this.hideTableShowSearch();
            return;
        }

        const data = {
            excludedIds: this.state.excludedIds,
            editedRenewals,
        };

        updateProcessingReport(this.state.data.selectedReport.id, data).then(response => {
            if (response.ok) {
                this.props.enqueueSnackbar(strings.renewalList.reportSaved, {
                    variant: "success",
                });
            }

            this.hideTableShowSearch();
        });
    }

    loadReport() {
        this.fetchReportPages(this.state.data.selectedReport.id);
    }

    fetchReportPages(reportId, page = 0, rawCount = 0, merged = []) {
        const FETCH_PAGE_SIZE = 500;

        loadProcessingReport(reportId, page, FETCH_PAGE_SIZE).then(response => {
            const newRawCount = rawCount + response.data.renewals.length;
            const newMerged = merged.concat(response.data.renewals);

            if (newRawCount < response.data.total) {
                this.fetchReportPages(reportId, page + 1, newRawCount, newMerged);
                return;
            }

            sortByGraveyardAndGraveSite(newMerged);

            this.setState({
                showTable: true,
                viewingSavedReport: true,
                excludedIds: [],
                editedItems: {},
                responseData: newMerged,
            }, () => {
                this.setState({
                    tableData: this.state.responseData,
                    total: newMerged.length,
                });
            });
        });
    }

    downloadPreReport() {
        generateRenewalPrePdf(this.state.data.selectedReport.id).then(response => {
            const blob = new Blob([response.data], { type: 'application/pdf' });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);

            const selectedReport = this.state.data.selectedReport;
            const periodFromDate = selectedReport.fromDate ? selectedReport.fromDate : this.state.data.renewalProcessingFromDate;
            const periodToDate = selectedReport.toDate ? selectedReport.toDate : this.state.data.renewalProcessingToDate;
            const period = `${dateToString3(periodFromDate)}-${dateToString3(periodToDate)}`;

            link.download = `Pre-Obrade-${period}.pdf`;

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);

            this.setState({
                loading: false,
            });
        })
    }

    find() {
        if (this.state.editedResult) {
            return;
        }

        const searchCriteria = {
            graveyardId: this.state.obj.selectedGraveyard != null ? this.state.obj.selectedGraveyard.id : -1,
            field: this.state.data.field != null ? this.state.data.field : "",
            plot: this.state.data.plot != null ? this.state.data.plot : "",
            graveSiteNumber: this.state.data.graveSiteNumber != null ? this.state.data.graveSiteNumber : "",
            fromDate: dateToStringDatePickerFormat3(this.state.data.renewalProcessingFromDate),
            toDate: dateToStringDatePickerFormat3(this.state.data.renewalProcessingToDate),
            companyId: this.state.companyId,
            userId: this.props.auth.user.id,
            selectedRenewalTypeKind: this.state.data.selectedRenewalTypeKind.id,
            // every booking code is always included; the screen no longer offers a choice
            leaseBookingCode: "-1",
        };

        this.setState({
            searchCriteria,
            excludedIds: [],
            editedItems: {},
        }, () => {
            this.fetchAllCandidates();
        });
    }

    fetchAllCandidates(page = 0, rawCount = 0, merged = []) {
        const FETCH_PAGE_SIZE = 500;

        getEditedRenewalsForProcessing({ ...this.state.searchCriteria, page, size: FETCH_PAGE_SIZE }).then(response => {
            const entities = (response && response.data && response.data.entities) || [];
            const total = (response && response.data && response.data.total) || 0;

            const newRawCount = rawCount + entities.length;
            const newMerged = merged.concat(entities);

            // keep paging only while the server still hands rows back; an empty page means
            // we are done even if the reported total is higher, which is what used to spin
            if (entities.length > 0 && newRawCount < total) {
                this.fetchAllCandidates(page + 1, newRawCount, newMerged);
                return;
            }

            sortByGraveyardAndGraveSite(newMerged);

            this.setState({
                showTable: true,
                viewingSavedReport: false,
                responseData: newMerged,
            }, () => {
                this.setState({
                    tableData: this.state.responseData,
                    total: newMerged.length,
                });
            });
        });
    }

    hideTableShowSearch() {
        this.setState({
            showTable: false,
            viewingSavedReport: false,
        })
    }

    // handleEditCompleted = () => {
    //     this.setState({
    //         editedResult: true
    //     }, () => {
    //         this.find();
    //     })
    // }

    handleEditCompleted = (modifiedItem) => {
        this.setState(prevState => {
            const modifiedData = prevState.responseData
                .map(current => {
                    return (current.id === modifiedItem.id)
                        ? modifiedItem
                        : current
                });

            return {
                responseData: modifiedData,
                tableData: modifiedData,
                editedItems: {
                    ...prevState.editedItems,
                    [modifiedItem.id]: modifiedItem,
                },
            };
        });
    }

    handleRemoveItemFromProcessingList = (item) => {
        this.setState(prevState => {
            const modifiedData = prevState.responseData.filter(current => current.id !== item.id);
            const editedItems = { ...prevState.editedItems };
            delete editedItems[item.id];

            return {
                responseData: modifiedData,
                tableData: modifiedData,
                total: modifiedData.length,
                excludedIds: [...prevState.excludedIds, item.id],
                editedItems,
            }
        });
    }

    handleGeneratePdf = (discount) => {
        this.setState({
            loading: true,
        });

        let data = {};

        if (discount) {
            data = {
                renewals: this.state.responseData.map(item => ({
                    ...item,
                    discount: true
                })),
                discounts: this.state.discounts ? this.state.discounts : [],
            }
        } else {
            data = {
                renewals: this.state.responseData,
                discounts: this.state.discounts ? this.state.discounts : [],
            }
        }

        // Two buttons: "Генериши ПДФ" applies the discounts entered above, "Генериши ПДФ
        // без попуста" must not — hence the separate endpoint, which drops the discount list.
        const generate = discount ? generateRenewalProcessingPdf : generateRenewalProcessingPdfWithoutDiscount;

        generate(data).then(response => {
            const blob = new Blob([response.data], { type: 'application/pdf' });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);

            const selectedReport = this.state.data.selectedReport ? this.state.data.selectedReport : {};
            const periodFromDate = this.state.data.renewalProcessingFromDate ? this.state.data.renewalProcessingFromDate : selectedReport.fromDate;
            const periodToDate = this.state.data.renewalProcessingToDate ? this.state.data.renewalProcessingToDate : selectedReport.toDate;
            const period = `${dateToString3(periodFromDate)}-${dateToString3(periodToDate)}`;

            link.download = discount ? `Obrade-${period}.pdf` : `Obrade-bez-popusta-${period}.pdf`;

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);

            this.setState({
                loading: false,
            });
        });
    }

    render() {
        return (
            <div className='header'>
                {this.getPageHeader()}
                {!this.state.showTable &&
                    <div>
                        <RenewalProcessingHeader
                            selectRenewalType={this.state.selectRenewalType}
                            selectRenewalTypeKind={this.state.selectRenewalTypeKind}
                            onChange={this.changeData}
                            selectedYear={this.state.data.selectedYear}
                            selectedRenewalType={this.state.obj != undefined ? this.state.obj.renewalType : ""}
                            selectedRenewalTypeKind={this.state.obj != undefined ? this.state.obj.renewalTypeKind : ""}
                            selectedGraveyard={this.state.data.selectedGraveyard}
                            selectedGraveSite={this.state.data.selectedGraveSite}
                            years={this.state.years}
                            graveyards={this.state.graveyards}
                            graveSites={this.state.graveSites}
                            autocompleteChange={this.onAutocompleteChange}
                            handleTextInputChange={this.handleTextInputChange}
                            onKeyDown={this.keyPressBackspace}
                            renewalType={this.state.obj != undefined ? this.state.obj.renewalType : ""}
                            find={this.find}
                            data={this.state.data}
                            obj={this.state.obj}
                        />
                        <RenewalProcessingReportHeader
                            onChange={this.changeData}
                            reports={this.state.reports}
                            selectedReport={this.state.data.selectedReport}
                            autocompleteChange={this.onAutocompleteChange}
                            handleTextInputChange={this.handleTextInputChange}
                            onKeyDown={this.keyPressBackspace}
                            load={this.loadReport}
                            preload={this.downloadPreReport}
                            data={this.state.data}
                            obj={this.state.obj}
                        />
                    </div>
                }

                {this.state.showTable &&
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <h4>Укупно резултата: {this.state.total}</h4>
                            <IconButton onClick={() => this.handleSaveReport()}>
                                <SaveIcon />
                                <Typography variant="button">{strings.review.buttons.saveProcessingReport}</Typography>
                            </IconButton>
                            <IconButton onClick={() => this.hideTableShowSearch()}>
                                <ArrowBackIosIcon />
                                <Typography variant="button">{strings.review.buttons.redefineSearch}</Typography>
                            </IconButton>
                        </div>
                        <RenewalProcessingResult
                            data={this.state.responseData}
                            total={this.state.total}
                            selectedRenewalTypeKind={this.state.data.selectedRenewalTypeKind}
                            hideTableShowSearch={this.state.showTable}
                            onEditCompleted={this.handleEditCompleted}
                            handleRemoveItemFromProcessingList={this.handleRemoveItemFromProcessingList}
                        />
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div>
                                <IconButton onClick={() => this.hideTableShowSearch()}>
                                    <ArrowBackIosIcon />
                                    <Typography variant="button">{strings.review.buttons.back}</Typography>
                                </IconButton>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <IconButton disabled={this.state.discounts.length >= 3} onClick={() => this.addNewDiscount()}>
                                    <AddIcon />
                                    <Typography variant="button">{strings.review.buttons.addDiscount}</Typography>
                                </IconButton>

                                {/* map discounts */}
                                {this.state.discounts.map((discount, index) => (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                                        <div style={{ marginRight: '4px' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                                <label style={{ marginRight: '10px', width: '80px', textAlign: 'right' }}>{strings.review.buttons.years}</label>
                                                <input
                                                    type="number"
                                                    value={discount.years}
                                                    style={{ width: '50px' }}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            discounts: update(this.state.discounts, { [index]: { years: { $set: parseInt(e.target.value) } } })
                                                        });
                                                    }}
                                                />
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <label style={{ marginRight: '10px', width: '80px', textAlign: 'right' }}>{strings.review.buttons.percent}</label>
                                                <input
                                                    type="number"
                                                    value={discount.percent}
                                                    style={{ width: '50px' }}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            discounts: update(this.state.discounts, { [index]: { percent: { $set: parseInt(e.target.value) } } })
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <DeleteIcon
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                                this.setState({
                                                    discounts: this.state.discounts.filter((_, i) => i !== index)
                                                });
                                            }}
                                        />
                                    </div>
                                ))}

                                <IconButton onClick={() => this.handleGeneratePdf(true)}>
                                    {this.state.loading
                                        ? (<CircularProgress size={24} color="inherit" />)
                                        : (<InsertDriveFileIcon />)
                                    }
                                    <Typography variant="button">{strings.review.buttons.generatePDF}</Typography>
                                </IconButton>

                                <IconButton onClick={() => this.handleGeneratePdf(false)}>
                                    {this.state.loading
                                        ? (<CircularProgress size={24} color="inherit" />)
                                        : (<InsertDriveFileIcon />)
                                    }
                                    <Typography variant="button">{strings.review.buttons.generatePDFDiscount}</Typography>
                                </IconButton>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeFullScreen: Actions.changeFullScreen
    }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
    return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

function renewalSearch() {
    return [
        { id: 0, value: null, name: strings.renewalTypes.all },
        { id: 1, value: strings.renewalTypes.submitterNameSurname, name: strings.renewalTypes.submitterNameSurname },
        { id: 2, value: strings.renewalTypes.deceasedNameSurname, name: strings.renewalTypes.deceasedNameSurname },
        { id: 3, value: strings.renewalTypes.graveSite, name: strings.renewalTypes.graveSite },
    ];
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(RenewalProcessingList)));
